import { combineReducers } from 'redux';
import integrationLogin from './login/reducer';

export default combineReducers({
  integrationLogin,
});
